export function isFindShortcut(event) {
  return (event.ctrlKey || event.metaKey) &&
    !event.altKey &&
    !event.shiftKey &&
    event.key.toLowerCase() === "f";
}

export function focusSearchForShortcut(event, input) {
  if (!isFindShortcut(event)) return false;

  event.preventDefault();
  input.focus();
  input.select();
  return true;
}
